var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90307 11.375C11.3177 10.4344 12.25 8.8261 12.25 7C12.25 4.1005 9.89949 1.75 7 1.75C6.59902 1.75 6.20855 1.79495 5.83333 1.88009M9.90307 11.375V9.33333M9.90307 11.375H11.9583M4.08333 2.63407C2.67635 3.57588 1.75 5.17976 1.75 7C1.75 9.89949 4.1005 12.25 7 12.25C7.40098 12.25 7.79145 12.205 8.16667 12.1199M4.08333 2.63407V4.66667M4.08333 2.63407H2.04167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.1f06b3451e6e71b749e67de53b122dd7.svg";
export { ForwardRef as ReactComponent };